<template>
	<footer>
		<view>人教点读 1-9年级正版教材点读</view>
		<view>Copyright ©2015-{{currentYear}} 人教点读</view>
		<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备11048806号</a>
	</footer>
</template>

<script>
	export default {
		data() {
			return {
				currentYear: new Date().getFullYear(), //当前年份
			}
		}
	}
</script>

<style lang="scss" scoped scoped>
	@import "@/style/components/footer.scss"; //引入样式文件
</style>